import { wrap } from "../_"

const pfx = "/badge"

export default (a: NuxtAxiosInstance) => ({
  generateBadge: (colleagueId = "", cfg?: AxiosConfig) => wrap(
    a.$post(`${pfx}/generate/${colleagueId}`, {},
      { responseType: "blob", ...cfg })),
})
